// Antd
import { Button } from 'antd'

// Interfaces
import { IBaseStepButtonProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'

const BaseStepButton = ({
  isBackCancel,
  isUsingBack,
  onBack,
  onNext,
  isBackLoading,
  isNextLoading,
  isNextDisabled,
  isFinish,
}: IBaseStepButtonProps) => {
  // Hook
  const { t } = useTranslation()

  return (
    <div className="w-full flex items-center justify-between gap-5">
      {isUsingBack ? (
        <Button className="custom-button common white" type="primary" onClick={onBack} loading={isBackLoading}>
          {t(`app.${isBackCancel ? 'cancel' : 'back'}`)}
        </Button>
      ) : (
        <></>
      )}

      <Button
        className="custom-button common"
        type="primary"
        htmlType="submit"
        onClick={onNext}
        loading={isNextLoading}
        disabled={isNextDisabled}
      >
        {isFinish ? t('app.submit') : t('app.next')}
      </Button>
    </div>
  )
}

export { BaseStepButton }
